__turbopack_context__.v({
  "app-message": "index-module-scss-module__4fzfkW__app-message",
  "failure": "index-module-scss-module__4fzfkW__failure",
  "inner-container": "index-module-scss-module__4fzfkW__inner-container",
  "show": "index-module-scss-module__4fzfkW__show",
  "success": "index-module-scss-module__4fzfkW__success",
});
